import Orders from '../Orders';
import Shipments from '../Shipments';
import ShipmentGroups from '../ShipmentGroups';

Shipments.setDependencyDocument('ShipmentGroups', ShipmentGroups);
ShipmentGroups.setDependencyDocument('Shipments', Shipments);
ShipmentGroups.setDependencyDocument('Orders', Orders);
Orders.setDependencyDocument('Shipments', Shipments);

export default Orders;
